/**
 * Frontend JavaScript — Entry Point
 *
 * This file is the main entry point for front-end scripts.
 * wp-scripts bundles and minifies this automatically.
 *
 * CSS imports are extracted to frontend.css by wp-scripts.
 */

// ── Styles ──────────────────────────────────────
import '../scss/frontend.scss';

// ── Modules ─────────────────────────────────────
import { initNavigation } from './modules/navigation';
import { initScrollEffects } from './modules/scroll';
import { initLazyModules } from './modules/lazy-loader';
import { initAccessibility } from './modules/accessibility';


// ── Init ────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
    initNavigation();
    initScrollEffects();
    initLazyModules();
    initAccessibility();
});
